import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {BankTransferApiResponse} from "../../../../types/courses/curses-by/get-bank-transfer/getBankTransfer";
import {setBankTransfer} from "../../../../slice/courses/get-bank-transfer/getBankTransferSlice";


export const getBankTransfer = createAsyncThunk(
    "courses/getBankTransfer",
    async (trackingId: string | undefined, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);

            const response = await axios.get<BankTransferApiResponse>(`/api/payments/bank-transfer/${trackingId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            thunkAPI.dispatch(setBankTransfer(response.data.data));

            return response.data;
        } catch (error) {
            // Обработка ошибки
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);